import { Box } from "@mui/material";
import ChatHeader from "../ChatHeader/ChatHeader";
import Chat from "../../../../../pages/Chat/Chat";
import { ICorporateEventMessage } from "../../../../../interfaces/corporateEvent";
import { SendbirdUIKitProvider } from "../../../../SendBird/SendbirdUIKitProvider";
import { defaultSendbirdGroupChannelUikitOptions } from "../../../../../constants/sendbirdConstants";
import "./sendbirdChatContiner.scss";

interface ISendbirdChatContinerProps {
	selectedChat: ICorporateEventMessage;
	vendorSendBirdId?: string | null;
	showWhatsAppIcon: boolean;
	showWhatsAppBanner: boolean;
	className?: string;
	showChatHeaderBackButton?: boolean;
	expanded?: boolean;
	setWhatsAppModalOpen: (open: boolean) => void;
	handleCloseChatClick: () => void;
	setWhatsappBannerVisible: (value: boolean) => void;
	handleSendbirdMessageUpdates?: () => void;
}

const SendbirdChatContiner = ({
	selectedChat,
	vendorSendBirdId,
	showWhatsAppIcon,
	showWhatsAppBanner,
	setWhatsAppModalOpen,
	handleCloseChatClick,
	className,
	showChatHeaderBackButton = true,
	setWhatsappBannerVisible,
	handleSendbirdMessageUpdates,
	expanded,
}: ISendbirdChatContinerProps) => {
	if (!selectedChat?.channelUrl) {
		return null;
	}

	const isNewModelChannel = selectedChat.isNewModelChannel === true;

	return (
		<Box
			className={`corporateEventChatContainer ${className || ""} ${expanded ? "corporateEventChatContainer__expanded" : ""}`}
		>
			<ChatHeader
				vendorName="YouCater Corporate Requests"
				whatsAppIconVisible={showWhatsAppIcon}
				onSocialClick={() => setWhatsAppModalOpen(true)}
				onBackClick={handleCloseChatClick}
				showBackButton={showChatHeaderBackButton}
			/>
			<SendbirdUIKitProvider
				isNewModelChannel={isNewModelChannel}
				vendorSendBirdId={vendorSendBirdId}
				channelUrl={selectedChat.channelUrl}
				className="corporateEventSendbirdProvider"
				uikitOptions={{
					groupChannel: defaultSendbirdGroupChannelUikitOptions,
				}}
			>
				<Chat
					chanelUrl={selectedChat?.channelUrl || ""}
					isWhatsappGroupCreated={selectedChat.isWhatsappGroupCreated}
					showWhatsAppBanner={showWhatsAppBanner}
					handleShowWhatsAppModal={() => setWhatsAppModalOpen(true)}
					handleShowWhatsAppBanner={setWhatsappBannerVisible}
					isCorporateEvent
					handleSendbirdMessageUpdates={handleSendbirdMessageUpdates}
				/>
			</SendbirdUIKitProvider>
		</Box>
	);
};

export default SendbirdChatContiner;
